<!-- <div class="appLayout">
    <ngx-spinner></ngx-spinner>
    <div [innerHTML]='errorMessage | safeHtml'></div>
</div> -->
<div [innerHTML]='errorMessage' class="appLayout accessError">
</div>
